export const DEFAULT_ENTRY_HELP = `# Hilfe zur Stundenerfassung

1. Wähle ein Datum innerhalb der letzten 10 Tage.
2. Erfasste Stunden in 0,5er-Schritten eintragen (z. B. 0.5, 1.0, 1.5 …).
3. Auftrag und Stundenart sorgfältig auswählen – sie bestimmen die spätere Auswertung.
4. Schreibe eine aussagekräftige Beschreibung (welche Tätigkeit, ggf. Ort/Kunde).

**Hinweis:** Bei Rückfragen zur Erfassung oder fehlenden Aufträgen bitte an die Administration wenden.`;

